module.exports = __webpack_public_path__ + "static/media/project-img7.fb13d04e.png";